import React, { useEffect, useState } from 'react';
import { apis, hooks, models } from "@vote4dance/judging-sdk";
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { Typography, Space, Row, Divider, Tabs, QRCode, Button, Collapse, Tag } from 'antd';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { _T } from "../../../../base-react/src/Localization";
var Stream = hooks.streams.Stream;
var RegistrationPeriodSource = models.registration.RegistrationPeriodSource;
import dayjs from 'dayjs';
import { RegistrationPeriodEdit } from './components/RegistrationPeriodEdit';
import { RegistrationClassList } from './components/RegistrationClassList';
import { useCompetition } from '../../../../base-react/hooks/Competition';
import { RegistrationPayout } from './components/RegistrationPayout';
import { RegistrationList } from './components/RegistrationList';
import { RegistrationTeamEdit } from './components/RegistrationTeamEdit';
import { PrinterOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { SortableList, SortableListItem } from '../../../../manager-react/components/SortableList';
import { notification } from 'antd';
var Api = apis.Api;
import { RegistrationTeamList } from './components/RegistrationTeamList';
import { RegistrationRulesModal } from './components/RegistrationRulesForm';
import { RegistrationRulesPreview } from './components/RegistrationRulesPreview';
import { DataTransfer } from '../data';
const { Title } = Typography;
export const Registration = () => {
    let { event_id, competition_id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const getTabFromHash = (hashValue) => {
        const tab = (hashValue || '').replace('#', '').trim();
        const allowedTabs = ['registrations', 'teams', 'periods', 'data'];
        return allowedTabs.includes(tab) ? tab : undefined;
    };
    const hashTab = getTabFromHash(location.hash);
    const [registrationPeriods, loadingRegistrationPeriods] = Stream(competition_id ? RegistrationPeriodSource(competition_id) : undefined);
    const [activeTab, setActiveTab] = useState(hashTab || 'registrations');
    const [tabInitialized, setTabInitialized] = useState(Boolean(hashTab));
    useEffect(() => {
        if (!hashTab) {
            return;
        }
        setActiveTab(hashTab);
        setTabInitialized(true);
    }, [hashTab]);
    useEffect(() => {
        if (tabInitialized || loadingRegistrationPeriods) {
            return;
        }
        setActiveTab((registrationPeriods && registrationPeriods.length > 0) ? 'registrations' : 'periods');
        setTabInitialized(true);
    }, [loadingRegistrationPeriods, registrationPeriods, tabInitialized]);
    const items = [
        {
            key: 'registrations',
            label: _T('registration.plural'),
            children: React.createElement(RegistrationList, { competition_id: competition_id })
        },
        {
            key: 'teams',
            label: _T('team.title'),
            children: React.createElement(RegistrationTeamList, { competition_id: competition_id })
        },
        {
            key: 'periods',
            label: _T('registrationperiod.title'),
            children: React.createElement(RegistrationPeriods, { event_id: event_id, competition_id: competition_id })
        },
        {
            key: 'data',
            label: _T('data.title'),
            children: React.createElement(DataTransfer, null)
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('registration.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(Tabs, { items: items, activeKey: activeTab, onChange: (nextTab) => {
                    setActiveTab(nextTab);
                    navigate(`${location.pathname}#${nextTab}`, { replace: true });
                } }))));
};
const RegistrationPeriods = (props) => {
    let { event_id, competition_id } = useParams();
    const [inputCompetition, event, competitions, loadingCompetition, errorCompetitions, canEdit] = useCompetition(competition_id);
    const [items, loadingItems] = Stream(RegistrationPeriodSource(competition_id));
    const getPrices = (item) => {
        const prices = item.registration_prices ? JSON.parse(item.registration_prices) : [];
        if (!prices) {
            return [];
        }
        return prices.map((price) => {
            const formatter = new Intl.NumberFormat('default', {
                style: 'currency',
                currency: item === null || item === void 0 ? void 0 : item.registration_currency,
                currencyDisplay: 'code'
            });
            return formatter.format(price.price);
        });
    };
    const onSorted = (list) => {
        const listIds = list ? list.map((e) => e.registration_period_id) : [];
        Api.call(RegistrationPeriodSource(competition_id).url, "set-order", listIds)
            .catch(err => {
            notification.error({
                message: _T(err.name)
            });
        });
    };
    const renderItem = (item) => {
        const now = dayjs();
        const start = dayjs.utc(item.registration_start_at).local();
        const end = dayjs.utc(item.registration_end_at).local();
        const statusConfig = start.isAfter(now)
            ? { color: 'orange', icon: React.createElement(ClockCircleOutlined, null) }
            : end.isBefore(now)
                ? { color: 'red', icon: React.createElement(CloseCircleOutlined, null) }
                : { color: 'green', icon: React.createElement(CheckCircleOutlined, null) };
        return (React.createElement(SortableListItem, { item: item, idAttribute: 'registration_period_id', element: () => React.createElement(Collapse, { collapsible: "header", style: { width: '100%' }, items: [
                    {
                        key: String(item.registration_period_id),
                        label: (React.createElement(Space, null,
                            item.registration_period_name,
                            React.createElement(Tag, { color: statusConfig.color, icon: statusConfig.icon }))),
                        children: (React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
                            start.format('LLL'),
                            end.format('LLL'),
                            item.registration_payment_type != 'free' && React.createElement(Space, { orientation: 'vertical' }, getPrices(item).map((price, index) => (`${_T('registrationperiod.details.registration_prices', { number: index + 1 })} ${price}`))),
                            item.registration_payment_type != 'free' && _T('registrationperiod.details.registration_price_per.label', { name: item.registration_price_per.toLowerCase() }),
                            item.registration_info,
                            React.createElement(RegistrationPeriodEdit, { item: item, event: event, competition: inputCompetition, disabled: !canEdit }),
                            React.createElement(RegistrationTeamEdit, { event_id: event_id, competition_id: competition_id, registration_period_id: item.registration_period_id, disabled: !canEdit }),
                            React.createElement(RegistrationRulesModal, { triggerLabel: _T('registration.rules.title'), item: item, competition_id: competition_id }),
                            React.createElement(RegistrationRulesPreview, { registration_rules: item.registration_period_rules, registration_form: item.registration_period_form }),
                            React.createElement(RegistrationClassList, { competition_id: competition_id, registration_period_id: item.registration_period_id })))
                    }
                ] }) }));
    };
    const origin = window.location.origin;
    var qrCodeLocation = `${origin}/public/event/${event_id}/comp/${competition_id}/registration`;
    return (React.createElement(Space, { orientation: 'vertical', style: { width: '100%' } },
        React.createElement(Row, { gutter: [16, 16] },
            React.createElement(SortableList, { contextId: 'sortRegistrationPeriods', loading: loadingItems, items: items || [], idAttribute: 'registration_period_id', renderItem: renderItem, onSorted: onSorted, style: { width: '100%' }, footer: canEdit ? React.createElement(RegistrationPeriodEdit, { event: event, competition: inputCompetition, disabled: !canEdit }) : undefined, disabled: !canEdit })),
        React.createElement(Divider, null),
        React.createElement(RegistrationPayout, { event: event, disabled: !canEdit }),
        React.createElement(Divider, null),
        React.createElement(QRCode, { value: qrCodeLocation }),
        React.createElement(Link, { to: qrCodeLocation }, _T('registration.qrcode-hint')),
        React.createElement(Link, { target: "_blank", to: `/print/${event_id}/registration` },
            React.createElement(Button, { icon: React.createElement(PrinterOutlined, null) }, _T('common.print')))));
};
